import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

// Components
import { Modal } from '@beef/ui-kit';
import { RequestStatus } from '@beef/smart-kit';
import { useSelector } from 'react-redux';
import { ErrorPopup } from '../ErrorPopup';
import { AddNumberForm } from '../AddNumberForm';

// Constants
import { POPUP_CONSTANTS, ERROR_POPUP_TYPES } from '../../constants';

// Selectors
import { getPersonalFamilyInfo } from '../../selectors';
import { ErrorDescriptionPopup } from '../ErrorDescriptionPopup';

const FamilyBeelineModal = ({ isPopupOpen, setPopupState, popupContent, invitedNumbers }) => {
  const { invitePriceData } = useSelector(getPersonalFamilyInfo);
  const [activePopup, setActivePopup] = useState(POPUP_CONSTANTS.addNumberPopup);
  const [errorType, setErrorType] = useState(ERROR_POPUP_TYPES.SMT_GOING_WRONG);
  const [finalCellNumber, setFinalCellNumber] = useState('');
  const history = useHistory();

  const [errorDescriptionData, setErrorDescriptionData] = useState(null);

  const invitedCellNumber = (input, replace) => {
    if (typeof input === 'string') {
      return input.replace('{{CELLNUMBER}}', replace);
    }
  };

  const errorContent = useMemo(() => {
    const { errorPopupGroup } = popupContent;
    const content = errorPopupGroup.find((errorObject) => errorObject.code === errorType);
    return content || errorPopupGroup[0];
  }, [errorType, popupContent]);

  const handlePopupClose = useCallback(() => {
    setPopupState(false);
    if (activePopup === POPUP_CONSTANTS.invitationSuccessPopup) {
      history.push('/');
    }
    setActivePopup(POPUP_CONSTANTS.addNumberPopup);
  }, [setPopupState, activePopup, setActivePopup]);

  const onBackClick = useCallback(() => setActivePopup(POPUP_CONSTANTS.addNumberPopup), []);
  const modalSize = activePopup === POPUP_CONSTANTS.errorDescriptionPopup ? 'm' : 's';

  return (
    <Modal
      isOpen={isPopupOpen}
      size={modalSize}
      isCentered
      onClose={handlePopupClose}
    >
      {(activePopup === POPUP_CONSTANTS.addNumberPopup) && (
        <AddNumberForm
          content={popupContent?.adNumberPopup}
          invitedNumbers={invitedNumbers}
          setActivePopup={setActivePopup}
          setErrorType={setErrorType}
          setFinalCellNumber={setFinalCellNumber}
          invitePriceData={invitePriceData}
          onErrorDescription={setErrorDescriptionData}
        />
      )}
      {(activePopup === POPUP_CONSTANTS.invitationSuccessPopup) && (
        <RequestStatus
          img={{
            src: popupContent?.invitationSuccess?.imageUrl,
          }}
          title={popupContent?.invitationSuccess?.title}
          description={invitedCellNumber(popupContent?.invitationSuccess?.description, finalCellNumber)}
          button={{
            text: popupContent?.invitationSuccess?.btnText,
            variant: 'secondary',
          }}
          onConfirm={handlePopupClose}
        />
      )}
      {(activePopup === POPUP_CONSTANTS.errorDescriptionPopup) && (
        <ErrorDescriptionPopup
          errorDescriptionData={errorDescriptionData}
          onBack={onBackClick}
          onClose={handlePopupClose}
        />
      )}
      {(activePopup === POPUP_CONSTANTS.invitationErrorPopup) && (
        <ErrorPopup
          title={errorContent.title}
          imageUrl={errorContent.imageUrl}
          arrowText={errorContent.arrowText}
          description={errorContent.description}
          buttonGroup={errorContent.buttonGroup}
          content={errorContent.content}
          onBack={onBackClick}
        />
      )}
    </Modal>
  );
};

FamilyBeelineModal.propTypes = {
  isPopupOpen: PropTypes.bool,
  setPopupState: PropTypes.func,
  popupContent: PropTypes.objectOf({
    adNumberPopup: PropTypes.object,
    invitationSuccess: PropTypes.objectOf({
      imageUrl: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      btnText: PropTypes.string,
    }),
    errorPopupGroup: PropTypes.objectOf({
      CTN_NOT_FOUND: PropTypes.object,
      DIFFERENT_REGIONS_ABONENT: PropTypes.object,
      SMT_GOING_WRONG: PropTypes.object,
    }),
  }),
  invitedNumbers: PropTypes.arrayOf({
  }),
};

export { FamilyBeelineModal };
